var c = Object.defineProperty;
var d = (s, e, t) => e in s ? c(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var a = (s, e, t) => d(s, typeof e != "symbol" ? e + "" : e, t);
import "../../index-LgiXwH_r.js";
import { StepParamsObjectSchemaHandler as p } from "./step-params-object-schema-handler.js";
import { F as m } from "../../index-gVtEopq1.js";
import { u } from "../../uniq-uUhGQWTe.js";
const l = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    cloudFunctionUrl: {
      type: "string"
    }
  },
  required: ["cloudFunctionUrl"]
};
class b extends p {
  constructor() {
    super(l, ["__fieldsConfig"]);
    a(this, "allowAdditionalFields", !0);
    a(this, "staticFields", Object.keys(l.properties));
  }
  getFields(t) {
    const { __fieldsConfig: i, ...n } = t ?? {};
    return u([
      ...this.staticFields,
      ...Array.isArray(i) ? i : Object.keys(n)
    ]).map((r) => ({
      fieldId: r,
      fieldName: r,
      type: m.String,
      label: r,
      required: !1,
      originalPath: [r]
    }));
  }
  getFieldsMap(t) {
    const i = this.getFields(t);
    return Object.fromEntries(
      i.map((o) => [o.fieldName, o])
    );
  }
}
export {
  b as CloudFunctionStepHandler
};
